import { render, staticRenderFns } from "./text-messaging-privacy-policy-addendum.vue?vue&type=template&id=449f0bb0&scoped=true&"
import script from "./text-messaging-privacy-policy-addendum.vue?vue&type=script&lang=js&"
export * from "./text-messaging-privacy-policy-addendum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449f0bb0",
  null
  
)

export default component.exports